<mat-dialog-content class="no-max-height">
  <ng-container [ngTemplateOutlet]="data.template"></ng-container>
</mat-dialog-content>
<mat-dialog-actions class="close-button">
  <app-button-group>
    <app-button (pressed)="onClose()" type="ghost" [tp]="translations.closeTp">X</app-button>
  </app-button-group>
</mat-dialog-actions>
